import { render, staticRenderFns } from "./SciApplicationUserReviews.vue?vue&type=template&id=4fa22ac4"
import script from "./SciApplicationUserReviews.vue?vue&type=script&lang=js"
export * from "./SciApplicationUserReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports